import { CustomError } from 'ts-custom-error';

import { setClassName } from '@change-corgi/core/error';

/**
 * Error passed to `onTokenInvalid` by the shared `PaypalButton` when the user closes the PayPal popup
 * without approving. It is a user outcome, not a failure, so handlers can skip reporting it with
 * `instanceof` while still reporting any other error that reaches `onTokenInvalid` for PayPal.
 */
export class PaypalCancelledError extends CustomError {
	constructor() {
		super('User cancelled paypal flow');
	}
}
setClassName(PaypalCancelledError, 'PaypalCancelledError');
